<template>
    <!--  서브페이지  -->
    <div id="sub_area">
        <!--비주얼 영역-->
        <div class="sub_visual">
            <div class="tit_area">
                <h2 class="tit">{{ title }}</h2>
            </div>

            <div class="navigation">
                <router-link to="/" class="i_home">
                    <span>HOME</span>
                </router-link>

                <div class="item" :class="{ on: mainMenuShow }" @mouseover="mainMenuShow = true"
                    @mouseleave="mainMenuShow = false">
                    <a>{{ title }}</a>
                    <div>
                        <router-link active-class="on" tag="a" to="/intro/establishment" @click.native="mainMenuShow = false">설립취지</router-link>
                        <router-link active-class="on" tag="a" to="/intro/history" @click.native="mainMenuShow = false">연혁</router-link>
                        <router-link active-class="on" tag="a" to="/intro/location" @click.native="mainMenuShow = false">오시는길</router-link>
                        
                    </div>
                </div>
            </div>
            <div class="sub_visual_img">
                <img :src="require('./../../assets/img/sub/sub03.png')" alt="BG" />
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    data: () => ({
        mainMenuShow: false,
        message: "CompanyMain.vue",
        title: ""
    }),
    methods: {
        textTitle(path) {
            switch (path) {
                case "/intro/establishment":
                    {
                        this.title = '설립취지';
                    }
                    break;
                case "/intro/history":
                    {
                        this.title = '연혁';
                    }
                    break;                
                case "/intro/location":
                    {
                        this.title = '오시는길';
                    }
                    break;
                
            }
        }
    },
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    watch: {
        $route(to, from) {
            this.textTitle(to.path);
        }
    },
    
    mounted() {
        
    },
    created() {
        console.log("created - " + this.message);

        this.textTitle(this.$route.path);
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub03/Sub03MainMenu.vue